<template>
  <div class="page-wrapper">   
    <div class="page-title">
      <CIcon name="cil-location-pin" /> Trek Details
      <span class="page-title-badge" v-if="report">{{ report.tripName }}</span>
    </div>
    <CRow v-if="report == null">
        <CCol md="12" class="text-center" v-if="reportError == ''">
            <strong>Loading...Please wait!</strong>
            <CProgress
                :value="100"
                color="primary"
                striped
                animated
                class="mb-2"
            />
        </CCol>
        <CCol md="12" class="text-center" v-else>
            <strong><CIcon name="cil-ban"/> {{reportError}}</strong>
        </CCol>
    </CRow>     
    <CRow v-else>
        <CCol md="12">
            <CCard>
                <CCardHeader class="text-center">
                        <strong>TREK INFO</strong>
                    </CCardHeader>
                <CCardBody>
                    <table class="table text-center" v-if="report.area">
                        <tr>
                            <td>Circle<br><b>{{report.area.circle}}</b></td>
                            <td>Division<br><b>{{report.area.division}}</b></td>
                            <td>Range<br><b>{{report.area.range}}</b></td>
                            <td>Block<br><b>{{report.area.block}}</b></td>
                            <td>Beat<br><b>{{report.area.beat}}</b></td>

                        </tr>
                    </table>
                    <table class="table">
                        <tr>
                            <td>Date : <b>{{new Date(report.date).toDateString()}}</b></td>
                            <td colspan="2">ID : <b>{{report.surveyid}}</b></td>
                        </tr>
                        <tr>
                            <td>
                                Start Time<br>
                                <b>{{new Date(report.startTime).toUTCString()}}</b>
                            </td>
                            <td>
                                Start GPS Lat<br>
                                <b>{{report.start_point.coordinates[1]}}</b>
                            </td>
                            <td>
                                Start GPS Long<br>
                                <b>{{report.start_point.coordinates[0]}}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                End Time<br>
                                <b>{{new Date(report.endTime).toUTCString()}}</b>
                            </td>
                            <td>
                                End GPS Lat<br>
                                <b>{{report.end_point.coordinates[1]}}</b>
                            </td>
                            <td>
                                End GPS Long<br>
                                <b>{{report.end_point.coordinates[0]}}</b>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Distance Covered<br>
                                <b>{{report.distance_covered.toFixed(2)}} km</b>
                            </td>
                            <td>
                                Area Covered<br>
                                <b>{{report.area_covered}}</b>
                            </td>
                            <td>
                                Trek Name<br>
                                <b>{{report.tripName}}</b>
                            </td>
                        </tr>
                    </table>
                    <table class="table">
                        <thead>
                            <td>Image</td>
                            <td><b>Name of species</b></td>
                            <td><b>Type of Sighting</b></td>
                            <td><b>Signs</b></td>
                            <td><b>Forest Type</b></td>
                            <td><b>Terrain Type</b></td>
                            <td><b>Remarks</b></td>                            
                        </thead>
                        <tbody>
                            <tr v-for="sighting in records" v-bind:key="sighting._id">
                                <td><img :src="sighting.image === undefined ? '/img/noimage.png' : baseURL + sighting.image" style="max-height : 200px"></td>
                                <td>{{sighting.species}} ({{sighting.animal_count}})</td>
                                <td>{{sighting.sighting_type}}</td>
                                <td>{{sighting.sighting_description}}</td>
                                <td>{{sighting.forest_type}}</td>
                                <td>{{sighting.terrain_type}}</td>
                                <td>{{sighting.comment}}</td>

                            </tr>
                        </tbody>
                        
                    </table>
                </CCardBody>
            </CCard>

        </CCol>
        <CCol md="12">
            <CCard>
                <CCardBody>
                    <div style="height: 500px; width: auto; margin : 10px" >
                        <l-map
                            v-if="!loading"
                            :zoom="zoom"
                            :center="center"
                            :options="mapOptions"
                            :bounds="bounds"
                        >
                            <l-tile-layer
                                :url="url"
                                :attribution="attribution"
                            />
                            <l-marker v-if="startPoint != null" :lat-lng="getLatLng(startPoint.lat, startPoint.lng)" :icon="greenIcon">
                                <l-popup>
                                <div>
                                    Trek Start Point    
                                    <!-- <CButton size="sm" color="success"  @click="openReport(record._id)"> Open </CButton> -->
                                </div>
                                </l-popup>
                            </l-marker>

                            <l-marker v-if="endPoint != null" :lat-lng="getLatLng(endPoint.lat, endPoint.lng)" :icon="redIcon">
                                <l-popup>
                                <div>
                                    Trek End Point    
                                    <!-- <CButton size="sm" color="success"  @click="openReport(record._id)"> Open </CButton> -->
                                </div>
                                </l-popup>
                            </l-marker>

                            <l-marker v-for="record in records" v-bind:key="record._id" :lat-lng="getLatLng(record.location.coordinates[1],record.location.coordinates[0])">
                                <l-popup>
                                <div>
                                    <b>{{record.sighting_type}}</b><br>
                                    Species : <b>{{record.animal_count}} {{record.species}}</b><br>
                                    Forest Type : <b>{{record.forest_type}}</b><br>
                                    Terrain Type : <b>{{record.terrain_type}}</b><br>                                    
                                    Date : <b>{{record.datetime.substring(0,10)}}</b><br>
                                </div>
                                </l-popup>
                            </l-marker>

                            <l-polyline
                                v-if="waypoints.length > 0"
                                :lat-lngs="waypoints"
                                color="#2E7D32"
                            />
                            
                            <l-control
                                :position="'bottomleft'"
                                class="custom-control-watermark"
                            >
                                Map generated by Strofes Technologies
                            </l-control>
                        </l-map>

                        <grid-loader :loading="loading" color="#2E7D32" ></grid-loader>
                    </div>
                </CCardBody>
            </CCard>          
        </CCol>
    </CRow>     
  </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import { latLng, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl, LPolyline } from "vue2-leaflet";
import { Icon } from 'leaflet';
import GridLoader from 'vue-spinner/src/GridLoader.vue'
export default {
    name: 'SingleReport',
    props : ['id'],
    components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LTooltip,
            LControl,
            Icon,
            GridLoader,
            LPolyline
    },
    data () {
        return {
            baseURL : store.state.baseURL,
            time : '',
            show: true,
            horizontal: { label:'col-3', input:'col-9' },
            formCollapsed: true,
            report : null,
            reportError : '',
            zoom: 13,
            bounds: null,            
            center: latLng(12.9716, 77.5946),
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            withPopup: latLng(47.41322, -1.219482),
            withTooltip: latLng(47.41422, -1.250482),
            currentZoom: 11.5,
            currentCenter: latLng(47.41322, -1.219482),
            largeModal : false,
            noimage : '/img/noimage.png',
            newStatus : '',
            startPoint : null,
            endPoint : null,
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            redIcon : null,
            greenIcon : null,
            loading : true,
            waypoints : [],
            records : []
            
        }
    },
    mounted(){
        delete Icon.Default.prototype._getIconUrl;
        Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        this.redIcon = L.icon({
            iconUrl: '/img/red_map_icon.png',
        });
        this.greenIcon = L.icon({
            iconUrl: '/img/green_map_icon.png',
        });
        this.getreport();
    },
    methods: {
        highlightRecord(id){
            alert(id);

        },
        getLatLng(lat, lng){
            return latLng(lat, lng);
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        today(){
            var date = new Date;;
            date = date.toISOString();
            return date.substring(0,10);
        },
        getreport(){
            axios({
                url : this.baseURL + "trip/get/"+this.id,
                headers : {
                    authorization : store.state.token
                },
                method : "GET"
            })
            .then(res => {
                if(res.data.status)
                {
                    this.report = res.data.data;   
                    this.report.image = this.report.image === undefined ? '/img/noimage.png' : this.baseURL + this.report.image,           

                    this.startPoint = {
                        lat : this.report.start_point.coordinates[1],
                        lng : this.report.start_point.coordinates[0]
                    }

                    this.endPoint = {
                        lat : this.report.end_point.coordinates[1],
                        lng : this.report.end_point.coordinates[0]
                    }                   


                    this.records = this.report.records;

                    for(var i = 0; i < this.report.waypoints.length; i++){
                        this.waypoints.push([this.report.waypoints[i]['lat'], this.report.waypoints[i]['lng']])
                    }

                    this.bounds = latLngBounds(this.waypoints)

                    // this.center = latLng(this.report.start_point.coordinates[1], this.report.start_point.coordinates[0])
                    this.loading = false;
                    

                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!\nCouldn\'t fetch data'
                });
                console.log(err);
                this.reportError = 'Something went wrong!\nCouldn\'t fetch data';
            });
        },
        // deleteRecord(){
        //     if(confirm('Are you sure? Do you want to delete the record?')){
        //         axios({
        //             url : this.baseURL + "report/delete",
        //             headers : {
        //                 authorization : store.state.token
        //             },
        //             method : "POST",
        //             data : {
        //                 id  : this.id
        //             }
        //         })
        //         .then(res => {
        //             if(res.data.status)
        //             {
        //                 this.$notify({
        //                     group: 'notification',
        //                     type : 'success',
        //                     title: 'Important message',
        //                     text: 'Successfully deleted. Please wait you are being redirected'
        //                 });   
        //                 this.$router.push({ path: `/alerts` });
                        
        //             }
        //             else
        //             {
        //                 this.$notify({
        //                     group: 'notification',
        //                     type : 'warn',
        //                     title: 'Important message',
        //                     text: res.data.message
        //                 });
        //             }
        //         })
        //         .catch(err => {
        //             this.$notify({
        //                 group: 'notification',
        //                 type : 'error',
        //                 title: 'Important message',
        //                 text: 'Something went wrong!\nCouldn\'t fetch data'
        //             });
        //             console.log(err);
        //             this.reportError = 'Something went wrong!\nCouldn\'t delete record';
        //         });
        //     }
        // },
        
    }
}
</script>
<style scoped>
    table, th, td {
        border: 1px solid black;
    }
</style>
